<template>
  <div id="app">
    <navbarapp ref="cmpNavbar" @logout='logout()' v-if="this.$root.auth"></navbarapp>
    <router-view/>
  </div>
</template>

<script>
import navbarapp from './components/Navbar'

export default {
  name: 'app',
  components: {
    navbarapp
  },
  data () {
    return {}
  },
  methods: {
    getStatusLogin (params) {
      const url = './api/php/login.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response)
          if (response.body.login) {
            const login = response.body.login
            if (!login.status) {
              console.log('LOGIN ERR: ' + login.msg)
              this.logout()
            } else {
              console.log('LOGIN AUTH')
              this.letmein(login)
            }
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    getStatusLogout (params) {
      const url = './api/php/logout.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response)
          this.$root.auth = false
          this.$router.push({path: '/'})
        },
        function (error) {
          console.log(error)
        }
      )
    },
    letmein (login) {
      this.$root.auth = true
      this.$root.nome = login.nome
      console.log('APP Ln: ' + login.nome)
      this.$root.cod = login.cod
      this.$root.nivel = login.nivel
    },
    logout () {
      this.getStatusLogout({})
    },
    focusIptSearch () {
      this.$refs.cmpNavbar.focusIptSearch()
    }
  },
  watch: {
    '$route' (to, from) {
      if (!this.$root.auth) {
        console.log('Cheking login via Router Change')
        this.getStatusLogin({})
      }
    }
  },
  created: function () {
    console.log('Cheking login via Created')
    if (!this.$root.auth) this.getStatusLogin({})
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
#app a{
  cursor: pointer
}
body{
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue